/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from "three";

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { controls } from '../../../../../redux/reducers/common/eventReducer';

import { extrudeSettings, railModel } from '../../../../../utils/Functions';
import BaseRailModel from '../../BaseRail';
import PillarRailModel from '../../Legs';
import CommonTruss from '../CommonTruss';
import { MaterialTruss } from '../../../CustomMaterial';
import { trussDimensions } from '../../../../../helpers/building_component/truss/truss.helper';

const SBST = ({ trussType, normalMap, envMap, trussModelPosInfoArr, overlapTrussArr, legDistance, meshDelModel_CSG, isFor  }) => {
    const [hiddenBaseRailIdArr, setHiddenBaseRailIdArr] = useState([]);
    const trussDimension = trussDimensions(isFor)

    useMemo(() => {
        let isHiddenBaseRailIndexArr = [];
        const heightestDoorArr = const_var.newDoorsArray.filter(e => e.positionY + e.height / 2 >= trussDimension.buildingHeight);
        
        if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_f_w')) isHiddenBaseRailIndexArr.push(trussModelPosInfoArr?.length - 1)
        if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_b_w')) isHiddenBaseRailIndexArr.push(0)
        if(params.p_d % legDistance === 0){
            if(heightestDoorArr.find(item => item.userData.wallName === 'c_b_f_s_w')) isHiddenBaseRailIndexArr.push(parseInt(params.p_u_t) / legDistance)
        }
        
        setHiddenBaseRailIdArr(isHiddenBaseRailIndexArr);
    }, [trussDimension.buildingHeight, const_var.newDoorsArray, params.p_u_t, params.p_d, params.fourth_center_cost, legDistance])

    return (
        <>
            {isFor == 'center' && <BaseRailModel normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />}
            {isFor == 'center' && <PillarRailModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} />}
            <TrussModel trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} overlapTrussArr={overlapTrussArr} hiddenBaseRailIdArr={hiddenBaseRailIdArr} isFor={isFor} />
        </>
    )
}

export default SBST

const TrussModel = ({ trussType, trussModelPosInfoArr, normalMap, envMap, overlapTrussArr, hiddenBaseRailIdArr, isFor }) => {
    const obj_centerVRail = new THREE.Object3D();
    const obj_centerHRail = new THREE.Object3D();

    const [centerVRail, setCenterVRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [centerHRail, setCenterHRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));

    const connectRailWidth = 0.3;
    const connectRailHeight = 0.2;
    const offset = 0.035;
    const trussDimension = trussDimensions(isFor)

    const alignPosOffset = useMemo(() => {
        if(params.p_r_s === 1 ) return const_var.roofRegularDst * 2;
        else if(params.p_r_s === 2 || params.p_r_s === 3) return 0;
        else return 0;
    }, [params.p_r_s, trussDimension.roofPitch])
    
    const roofAlpha = Math.atan(trussDimension.roofPitch / 12);
    const roofCenterRailHeight = (trussDimension.buildingWidth / 2) * trussDimension.roofPitch / 12;

    const connectRailModelDataArr = useMemo(() => {
        let dataInfoArray = [];

        const distance = 5;
        const count = Math.floor((trussDimension.buildingWidth / 2) / distance)
        for (let i = 1; i < count; i++) {
            const pos_x = distance * i;
            const verticalRailHeight = trussDimension.roofPitch / 12 * (trussDimension.buildingWidth / 2 - pos_x) - connectRailHeight / 2;
            const slopeRailHeight = Math.sqrt(Math.pow(verticalRailHeight, 2) + Math.pow(distance, 2));

            const alphaDeviation = 0.97;
            const slopeRailAlpha = (Math.PI / 2 - Math.atan(verticalRailHeight / distance)) / alphaDeviation;
            
            const tempInfoObj = {
                distance: distance,
                pos_x: pos_x,
                verticalRailHeight: verticalRailHeight,
                slopeRailHeight: slopeRailHeight,
                slopeRailAlpha: slopeRailAlpha
            }

            dataInfoArray.push(tempInfoObj);
        }

        return dataInfoArray
    }, [trussDimension.buildingWidth, trussDimension.roofPitch])

    // const railConnectModel = useMemo(() =>{
    //     const meshModel = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(connectRailWidth, connectRailHeight), extrudeSettings(sideEdgeSlopeRailLength - 0.65)), new THREE.MeshStandardMaterial({ color: 'brown' , side: THREE.DoubleSide}))
    //     const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(connectRailWidth, connectRailHeight + 0.2), extrudeSettings(0.2)), new THREE.MeshStandardMaterial({ color: 'green' , side: THREE.DoubleSide}))

    //     const meshModel_Temp = meshModel.clone()
    //     meshModel_Temp.updateMatrixWorld();

    //     const meshDelModel_Temp = meshDelModel.clone()
    //     meshDelModel_Temp.position.set(0, 0 - 0.03, sideEdgeSlopeRailLength - 0.72);
    //     meshDelModel_Temp.rotateX(-sideEdgeSlopeRailAlpha);
        
    //     meshDelModel_Temp.updateMatrixWorld();

    //     const meshModel_CSG = CSG.fromMesh(meshModel_Temp)
    //     const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp)

    //     const Model_CSG = meshModel_CSG.subtract(meshDelModel_CSG)
    //     const CSGMeshModel = CSG.toMesh(
    //         Model_CSG,
    //         new THREE.Matrix4(),
    //         new THREE.MeshStandardMaterial({ color: 'grey', side:THREE.DoubleSide })
    //     )

    //     return CSGMeshModel
    // }, [sideEdgeSlopeRailAlpha, sideEdgeSlopeRailLength])

    useMemo(() => {
            const instancedMatCenterVRail = [];
            const instancedMatCenterHRail = [];
            new Array(2).fill('').forEach((_, index_dir) => {
                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    //----- bottom base rail-----
                    obj_centerHRail.position.set(-trussDimension.buildingWidth / 2 + (params.p_r_s === 1 ? 0.5 : 0.05), trussDimension.buildingHeight - connectRailHeight / 2 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_centerHRail.rotation.y = Math.PI / 2;
                    //---------------------

                    //----- roof center rail-----
                    obj_centerVRail.position.set(0, trussDimension.buildingHeight - connectRailHeight + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_centerVRail.rotation.x = -Math.PI / 2;
                    //---------------------

                    if (hiddenBaseRailIdArr.includes(index_truss)) {
                        obj_centerHRail.scale.setScalar(0);
                        obj_centerVRail.scale.setScalar(0);
                    } else {
                        obj_centerHRail.scale.setScalar(1);
                        obj_centerVRail.scale.setScalar(1);
                    }

                    obj_centerVRail.updateMatrix();
                    instancedMatCenterVRail.push(...obj_centerVRail.matrix.elements);
                    obj_centerHRail.updateMatrix();
                    instancedMatCenterHRail.push(...obj_centerHRail.matrix.elements);
                })
            })

            setCenterVRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatCenterVRail), 16));
            setCenterHRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatCenterHRail), 16));
            
    }, [trussDimension.buildingWidth, trussDimension.buildingHeight, params.p_r_s,  trussModelPosInfoArr, overlapTrussArr, hiddenBaseRailIdArr, connectRailModelDataArr, alignPosOffset, roofAlpha, controls.isCheckActiveTab, params.activeWall])

    return (
        <group position={[0, -offset, 0]} rotation={[0,trussDimension.trussRotation,0]} name='SBST-truss-legs'>
            <CommonTruss trussType={trussType} trussModelPosInfoArr={trussModelPosInfoArr} overlapTrussArr={overlapTrussArr} normalMap={normalMap} envMap={envMap} isFor={isFor}/>
            <>
                {/* --- bottom base rail model --- */}
                {
                    centerHRail.array.length > 0 && [1].map(() => <instancedMesh instancedMesh key={centerHRail.array.length} instanceMatrix={centerHRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(trussDimension.buildingWidth - (params.p_r_s === 1 ? 1 : 0.1))]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}

                {/* --- roof center rail model --- */}
                {
                    centerVRail.array.length > 0 && [1].map(() => <instancedMesh key={centerVRail.array.length} instanceMatrix={centerVRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings(roofCenterRailHeight)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
                }
                {/* ------------------------- */}

                {/* --- connect rail model --- */}
                {connectRailModelDataArr.map((_, index) =>
                    <group name='SBST-truss-rail-legs'>
                        <ConnectVRailModel
                            index={index}
                            trussModelPosInfoArr={trussModelPosInfoArr}
                            connectRailModelDataArr={connectRailModelDataArr}
                            connectRailHeight={connectRailHeight}
                            alignPosOffset={alignPosOffset}
                            hiddenBaseRailIdArr={hiddenBaseRailIdArr}
                            overlapTrussArr={overlapTrussArr}
                            connectRailWidth={connectRailWidth}
                            roofAlpha={roofAlpha}
                            normalMap={normalMap}
                            envMap={envMap}
                            isFor={isFor}
                        />
                        <ConnectSRailModel
                            index={index}
                            trussModelPosInfoArr={trussModelPosInfoArr}
                            connectRailModelDataArr={connectRailModelDataArr}
                            connectRailHeight={connectRailHeight}
                            alignPosOffset={alignPosOffset}
                            hiddenBaseRailIdArr={hiddenBaseRailIdArr}
                            overlapTrussArr={overlapTrussArr}
                            connectRailWidth={connectRailWidth}
                            roofAlpha={roofAlpha}
                            normalMap={normalMap}
                            envMap={envMap}
                            isFor={isFor}
                        />
                    </group>
                )}
                {/* ------------------------- */}
            </>
        </group>
    )
}


const ConnectVRailModel = ({ index, trussModelPosInfoArr, connectRailModelDataArr, alignPosOffset, hiddenBaseRailIdArr, overlapTrussArr, connectRailHeight, connectRailWidth, roofAlpha, normalMap, envMap, isFor }) => {
    const obj_connectVRail = new THREE.Object3D();
    const [connectVRail, setConnectVRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const trussDimension = trussDimensions(isFor)

    useMemo(() => {

            let index_all = 0;
            const instancedMatConnectVRail = [];
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1;

                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    obj_connectVRail.position.set(offsetForDir * connectRailModelDataArr[index].pos_x, trussDimension.buildingHeight - connectRailHeight + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_connectVRail.rotation.x = -Math.PI / 2;

                    if (hiddenBaseRailIdArr.includes(index_truss)) {
                        obj_connectVRail.scale.setScalar(0);
                    } else {
                        obj_connectVRail.scale.setScalar(1);
                    }

                    obj_connectVRail.updateMatrix();
                    instancedMatConnectVRail.push(...obj_connectVRail.matrix.elements);
                    
                    index_all ++;
                })
            })
            
            setConnectVRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatConnectVRail), 16));

    }, [trussDimension.buildingWidth, trussDimension.buildingHeight, params.singleSlope, params.freeStandingSide, trussModelPosInfoArr, overlapTrussArr, trussDimension.buildingWidth, trussDimension.buildingHeight, roofAlpha, connectRailModelDataArr, hiddenBaseRailIdArr, alignPosOffset])
    
    return (
            connectVRail.array.length > 0 && [1].map(() => <instancedMesh key={connectVRail.array.length} instanceMatrix={connectVRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
                <extrudeGeometry args={[railModel(connectRailHeight, connectRailWidth), extrudeSettings(connectRailModelDataArr[index].verticalRailHeight)]} />
                <MaterialTruss normalMap={normalMap} envMap={envMap} />
            </instancedMesh>)
    )
}

const ConnectSRailModel = ({ index, trussModelPosInfoArr, connectRailModelDataArr, alignPosOffset, hiddenBaseRailIdArr, overlapTrussArr, connectRailHeight, connectRailWidth, roofAlpha, normalMap, envMap, isFor }) => {
    const obj_connectSRail = new THREE.Object3D();
    const [connectSRail, setConnectSRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const vector = new THREE.Vector3(1, 0, 0)
    const trussDimension = trussDimensions(isFor)

    useMemo(() => {

            let index_all = 0;
            const instancedMatConnectSRail = [];
            new Array(2).fill('').forEach((_, index_dir) => {
                let offsetForDir = 1;
                if (index_dir === 0) offsetForDir = 1;
                else offsetForDir = -1;

                new Array(trussModelPosInfoArr.length).fill('').forEach((_, index_truss) => {
                    obj_connectSRail.position.set(offsetForDir * (connectRailModelDataArr[index].pos_x - connectRailModelDataArr[index].distance), trussDimension.buildingHeight - connectRailHeight + connectRailWidth / 2 + alignPosOffset, trussModelPosInfoArr[index_truss]);
                    obj_connectSRail.rotation.y = offsetForDir * -Math.PI / 2;
                    obj_connectSRail.rotateOnAxis(vector, offsetForDir * (-Math.PI / 2 - connectRailModelDataArr[index].slopeRailAlpha));

                    if (hiddenBaseRailIdArr.includes(index_truss)) {
                        obj_connectSRail.scale.setScalar(0);
                    } else {
                        obj_connectSRail.scale.setScalar(1);
                    }
                    obj_connectSRail.updateMatrix();

                    instancedMatConnectSRail.push(...obj_connectSRail.matrix.elements);

                    index_all ++;
                })
            })

            setConnectSRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatConnectSRail), 16));
    }, [trussDimension.buildingWidth, trussDimension.buildingHeight, params.singleSlope, params.freeStandingSide, trussModelPosInfoArr, overlapTrussArr, trussDimension.buildingWidth, trussDimension.buildingHeight, roofAlpha, connectRailModelDataArr, hiddenBaseRailIdArr, alignPosOffset])
    
    return (
        connectSRail.array.length > 0 && [1].map(() => <instancedMesh key={connectSRail.array.length} instanceMatrix={connectSRail} instanceMatrix-needsUpdate={true} args={[null, null, trussModelPosInfoArr.length * 2]} frustumCulled={false}>
            <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(connectRailModelDataArr[index].slopeRailHeight)]} />
            <MaterialTruss normalMap={normalMap} envMap={envMap} />
        </instancedMesh>)
    )
}
